import React from "react";
import ClientInfo from "../../atoms/ClientInfo/view";
import AccountFilterSelector from "../AccountRangeSelector/view";
import ThirdPartySearch from "../ThirdPartySearch/view";
import DocumentTypeMultiselect from "../DocumentTypeMultiselect/view";
import { Col, Row } from "react-bootstrap";
import Tooltip from "@mui/material/Tooltip";
import { HelpCircle } from "lucide-react";

import TaxTypeSelector from "../TaxTypeSelector/view";
import FormToggle from "../FormToggle/view";

import MonthYearSelector from "../MonthYearSelector/view";
import AccountSearchDropdown from "../AccountSearchDropdown/view";
import MultiProductSearchDropdown from "../MultiProductSearchDropdown/view";

const componentsMap = {
  third: ClientInfo,
  account_selector: AccountFilterSelector,
  third_party_search: ThirdPartySearch,
  document_type_multiselect: DocumentTypeMultiselect,
  tax_type_selector: TaxTypeSelector,
  include_thirds_toggle: FormToggle,
  month_year_selector: MonthYearSelector,
  utility_account_selector: AccountSearchDropdown,
  product_search_multiselect: MultiProductSearchDropdown
};

const FILTER_TOOLTIPS = {
  third: "Información detallada del tercero asociado.",
  account_selector: "Permite filtrar por cuentas específicas o por un rango de códigos contables.",
  third_party_search: "Busca y selecciona un tercero específico para filtrar los movimientos.",
  document_type_multiselect: "Filtra el reporte por tipos de documentos o comprobantes contables (ej. Facturas, Egresos).",
  tax_type_selector: "Selecciona el tipo de impuesto a reportar (ej. IVA, Retención o Todos).",
  include_thirds_toggle: "Si se activa, el reporte detallará los movimientos desglosados por tercero.",
  month_year_selector: "Selecciona el mes y año contable para el cálculo del reporte.",
  utility_account_selector: "Cuenta contable requerida para procesar la utilidad/pérdida del periodo.",
  product_search_multiselect: "Filtra los movimientos contables asociados a productos específicos."
};

export function DynamicForm({ componentName, componentProps }) {
  const ComponentToRender = componentsMap[componentName];
  if (!ComponentToRender) return <div>Componente no encontrado</div>;

  const tooltipText = FILTER_TOOLTIPS[componentName];

  return (
    <Row>
      <Col>
        {tooltipText && (
          <div style={{ display: 'flex', alignItems: 'center', gap: '4px', marginBottom: '6px' }}>
            <Tooltip title={tooltipText} arrow placement="top-start">
              <span style={{ cursor: 'pointer', display: 'inline-flex', alignItems: 'center', color: 'var(--color-gray-80, #666)', gap: '4px', fontSize: '0.75rem', fontWeight: 500 }}>
                <HelpCircle size={13} /> Ayuda sobre este filtro
              </span>
            </Tooltip>
          </div>
        )}
        <ComponentToRender {...componentProps} />
      </Col>
    </Row>
  );
}
